import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePagination = (initialPage: number = 1, pageKey: string = 'page') => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(() => {
    const paramsPage = Number(searchParams.get(pageKey));
    return paramsPage || initialPage;
  });

  const handleSetPage = useCallback((p: number) => {
    setPage(p);
    setSearchParams({ [pageKey]: p.toString() });
  }, []);

  return { page, setPage: handleSetPage };
};
